<div class="container my-4 organisation-list">
  <h2 class="mb-4">Organisations</h2>

  <div class="row">
    <div *ngFor="let organisation of organisations; let i = index" class="col-12 mb-4">
      <div class="card shadow-sm">
        <div class="card-body">
          <h3 class="card-title">{{ organisation.name }}</h3>

          <button class="btn btn-sm btn-outline-secondary mb-2"
                  type="button"
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#orgDetails' + i"
                  aria-expanded="false"
                  [attr.aria-controls]="'orgDetails' + i">
            Toggle Details
          </button>

          <div [id]="'orgDetails' + i" class="collapse mt-3">
            <p class="card-text"><strong>Description:</strong> {{ organisation.description }}</p>
            <p class="card-text"><strong>Email:</strong> {{ organisation.email }}</p>
            <p *ngIf="organisation.phone" class="card-text"><strong>Phone:</strong> {{ organisation.phone }}</p>
            <p *ngIf="organisation.address" class="card-text"><strong>Address:</strong> {{ organisation.address }}</p>
            <p *ngIf="organisation.type" class="card-text"><strong>Type:</strong> {{ organisation.type }}</p>
            <p *ngIf="organisation.postalCode" class="card-text"><strong>Postal Code:</strong> {{ organisation.postalCode }}</p>
            <p *ngIf="organisation.taxNumber" class="card-text"><strong>Tax Number:</strong> {{ organisation.taxNumber }}</p>
            <p *ngIf="organisation.IBAN" class="card-text"><strong>IBAN:</strong> {{ organisation.IBAN }}</p>
            <p *ngIf="organisation.VATNumber" class="card-text"><strong>VAT Number:</strong> {{ organisation.VATNumber }}</p>

            <div *ngIf="organisation.leaders?.length">
              <h5 class="mt-4">Leaders</h5>
              <div *ngFor="let leader of organisation.leaders" class="border rounded p-2 mb-2">
                <p class="mb-1"><strong>Name:</strong> {{ leader.name }}</p>
                <p class="mb-1"><strong>Role:</strong> {{ leader.role }}</p>
                <p class="mb-1"><strong>Email:</strong> {{ leader.email }}</p>
                <p class="mb-1"><strong>Phone:</strong> {{ leader.phone }}</p>
                <img *ngIf="leader.imageRef" [src]="leader.imageRef" alt="{{ leader.name }}"
                     class="img-fluid rounded mt-2" style="max-width: 150px;" />
              </div>
            </div>

            <div *ngIf="organisation.administrators?.length">
              <h5 class="mt-3">Administrators</h5>
              <ul class="list-group">
                <li *ngFor="let admin of organisation.administrators"
                    class="list-group-item d-flex justify-content-between align-items-center">
                  {{ admin.username }} - {{ admin.role }}
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteAdmin(admin.id!)">
                    Remove
                  </button>
                </li>
              </ul>
            </div>

            <div class="mt-3">
              <h6>Add New Administrator</h6>
              <div class="row">
                <div class="col-md-2">
                  <input type="text" class="form-control" placeholder="Username" [(ngModel)]="newAdmin.username">
                </div>
                <div class="col-md-2">
                  <input type="password" class="form-control" placeholder="Password" [(ngModel)]="newAdmin.password">
                </div>
                <div class="col-md-2">
                  <input type="email" class="form-control" placeholder="Email" [(ngModel)]="newAdmin.contact_email">
                </div>
                <div class="col-md-2">
                  <input type="text" class="form-control" placeholder="Role" [(ngModel)]="newAdmin.role">
                </div>
                <div class="col-md-2">
                  <button class="btn btn-primary w-100" (click)="addAdmin(organisation.organisationID)">Add</button>
                </div>
              </div>
            </div>

            <button class="btn btn-sm btn-outline-primary mt-3" (click)="editOrganisation(organisation)">
              Edit
            </button>
            <button type="button" class="btn btn-danger mt-3 ms-2" (click)="deleteOrganisation(organisation.organisationID)">
              Delete Organisation
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="container my-4" #orgFormSection>
  <!-- Toggle Button -->
  <button class="btn btn-outline-primary mb-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#orgFormCollapse"
          aria-expanded="false"
          aria-controls="orgFormCollapse">
    {{ isEditMode ? 'Edit Organisation' : 'Add New Organisation' }}
  </button>

  <!-- Collapsible Form -->
  <div class="collapse" id="orgFormCollapse">
    <h2 class="mb-4">{{ isEditMode ? 'Edit Organisation' : 'Add New Organisation' }}</h2>

    <form [formGroup]="organisationForm" (ngSubmit)="submitOrganisation()">
      <div class="row">
        <div class="col-md-6 mb-3" *ngFor="let field of [
          { label: 'Name', key: 'name' },
          { label: 'Description', key: 'description' },
          { label: 'Email', key: 'email' },
          { label: 'Phone', key: 'phone' },
          { label: 'Address', key: 'address' },
          { label: 'Type', key: 'type' },
          { label: 'Postal Code', key: 'postalCode' },
          { label: 'Tax Number', key: 'taxNumber' },
          { label: 'IBAN', key: 'IBAN' },
          { label: 'VAT Number', key: 'VATNumber' }
        ]">
          <label class="form-label">{{ field.label }}</label>
          <input type="text" class="form-control" [formControlName]="field.key" />
          <div class="text-danger"
               *ngIf="organisationForm.get(field.key)?.invalid && organisationForm.get(field.key)?.touched">
            {{ field.label }} is required.
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary mt-3" [disabled]="organisationForm.invalid">
        {{ isEditMode ? 'Update Organisation' : 'Add Organisation' }}
      </button>

      <button type="button" *ngIf="isEditMode" class="btn btn-secondary mt-3 ms-2" (click)="resetForm()">
        Cancel
      </button>
    </form>
  </div>
</div>


<app-farm-list [allFarms]="allFarms" [isOnMarketPage]="isOnMarketPage" [isOnAdminPage]="true"></app-farm-list>
<app-all-users></app-all-users>
<div class="event-container">
    <app-event-list [allEvents]="allEvents" [allFarms]="allFarms" [onAdminPage]="true"></app-event-list>
</div>


